import { Component, OnInit } from '@angular/core';
import { Subject, catchError, of, takeUntil, tap } from 'rxjs';
import { LoggingService } from 'src/app/shared/Services/NGLogger/logging-service.service';
import { LoaderService } from 'src/app/shared/Services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  private componentDestroyed$: Subject<void> = new Subject(); // For unsubscribing when the component is destroyed
  showLoader: boolean = false;

  constructor(
    private loaderService: LoaderService,
    private loggingService: LoggingService 
  ) { }

  ngOnInit() {
    this.loaderService.loaderState$
    .pipe(tap((state) => {
      this.showLoader = state;
    }),
    catchError((error) =>{
      this.loggingService.captureException(error); 
      return of(null);
    }),
    takeUntil(this.componentDestroyed$)
    )
    .subscribe();
  }

  cancelLoading() {
    this.loaderService.showLoader(false);
  }
}
